module.exports = __webpack_public_path__ + "f6a91eb94ea5d7a7291834acc09f1271.png";


//////////////////
// WEBPACK FOOTER
// ./lib/rlink-promotiles/assets/placeholder.png
// module id = 27
// module chunks = 0